<template>
  <div
    class="layout-topbar tw:flex tw:justify-between tw:h-[113px] tw:pt-[67px] tw:pb-[28px] tw:px-[16px] tw:gap-x-[16px]"
    :class="overlay
      ? 'tw:absolute tw:top-0 tw:left-0 tw:right-0 tw:z-20 tw:bg-transparent pointer-events-none'
      : ''"
  >
    <div
      class="layout-topbar-back-container tw:flex tw:gap-x-[4px] tw:self-center tw:cursor-pointer"
      :class="[
        overlay ? 'pointer-events-auto' : '',
        { 'tw:opacity-0 tw:pointer-events-none': getTopbarHideLeft }
      ]"
      @click="sendBackEvent"
    >
      <template v-if="getTopbarShowCloseButton">
        <i
          :class="['pi pi-chevron-left', backColorClass, 'tw:self-center']"
          style="font-size: 14px; font-weight: 600"
        ></i>
        <span :class="[backColorClass, 'tw:text-[16px] tw:font-semibold leading-[18px]']">Close</span>
      </template>
      <template v-else-if="!getTopbarNavigationTimeLabel">
        <i
          :class="['pi pi-chevron-left', backColorClass, 'tw:self-center']"
          style="font-size: 14px; font-weight: 600"
        ></i>
        <span :class="[backColorClass, 'tw:text-[16px] tw:font-semibold leading-[18px]']">Back</span>
      </template>
      <template v-else>
        <Avatar :image="avatarUrl" shape="circle" class="tw:size-8" alt="Medicia"/>
      </template>
    </div>
    <div class="layout-topbar-content-container tw:self-center tw:flex tw:flex-col" :class="overlay ? 'pointer-events-none' : ''">
      <div class="tw:text-[16px] tw:font-bold tw:text-black tw:leading-[18px] tw:text-center">
        {{ getTopbarNavigationTitle }}
      </div>
      <span
        v-if="getTopbarNavigationTimeLabel"
        class="tw:text-[#8A8A8C] tw:mx-auto tw:text-[12px] tw:font-semibold tw:leading-[15px]"
        >{{ getTopbarNavigationTimeLabel }}</span
      >
    </div>
    <div
      class="layout-topbar-action-container tw:self-center tw:cursor-pointer"
      :class="[
        overlay ? 'pointer-events-auto' : '',
        { 'tw:opacity-0 pointer-events-none': !getTopbarProcessTitle }
      ]"
      @click="sendProceedEvent"
    >
      <template v-if="getTopbarProcessTitle?.startsWith('__ICON_SORT')">
        <Button variant="link">
          <i :class="sortIconClass" class="tw:text-[#007AFF] tw:text-[18px]"></i>
        </Button>
      </template>
      <template v-else>
        <span
          class="text-main tw:text-[16px] tw:font-semibold leading-[18px] tw:min-w-[60px] tw:inline-block tw:text-right"
          >{{ getTopbarProcessTitle }}</span
        >
      </template>
    </div>
  </div>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { EventBusEnum } from '@/helpers/enums';
import { useEventBus } from '@/composables/useEventBus';
import { useAppStore } from '@/stores/app-store';
import { useAuthStore } from '@/stores/auth-store';

const {
  getTopbarNavigationTitle,
  getTopbarProcessTitle,
  getTopbarNavigationTimeLabel,
  getTopbarShowCloseButton,
  getTopbarHideLeft,
} = storeToRefs(useAppStore());

const props = defineProps({ overlay: { type: Boolean, default: false } });

const { ME } = storeToRefs(useAuthStore());
const { emitEvent } = useEventBus();

const sendBackEvent = () => {
  emitEvent(EventBusEnum.TOPBAR_BACK);
};

const sendProceedEvent = () => {
  emitEvent(EventBusEnum.TOPBAR_PROCEED);
};

const sortIconClass = computed(() => {
  const v = getTopbarProcessTitle?.value;
  switch (v) {
    case '__ICON_SORT_UP__':
      return 'pi pi-sort-alpha-up';
    case '__ICON_SORT_DOWN__':
      return 'pi pi-sort-alpha-down';
    case '__ICON_SORT_BOOKMARK__':
      return 'pi pi-bookmark';
    case '__ICON_SORT_BOOKMARK__FULL__':
      return 'pi pi-bookmark-fill';
    default:
      return 'pi pi-ellipsis-v';
  }
});

const avatarUrl = computed(() => ME.value?.avatar || '/images/avatars/profile.png');

const backColorClass = computed(() => (props.overlay ? 'tw:text-white' : 'text-main'));
</script>
